module.exports = __webpack_public_path__ + "static/media/file-plus.82ef3a0b.svg";